import {
  AirConditionerIcon,
  LocationIcon,
  LockIcon,
  ProfileIcon,
  ReceiptIcon,
  WishlistIcon,
} from "~/design-system/components/icons";
import { NavLinkType } from "~/layouts/common-layout/components/Header/types";
import { URLS } from "~/shared/urls";

export const profileNavItems: NavLinkType[] = [
  {
    label: "profile.accountDetails",
    icon: ProfileIcon,
    href: URLS.profile.root,
  },
  {
    label: "profile.changePassword",
    icon: LockIcon,
    href: URLS.profile.changePassword,
  },
  {
    label: "profile.devices",
    icon: AirConditionerIcon,
    href: URLS.profile.devices,
  },
  {
    label: "profile.ordersHistory",
    icon: ReceiptIcon,
    href: URLS.profile.ordersHistory.root,
    baseURL: URLS.profile.ordersHistory.root,
  },
  {
    label: "profile.addresses",
    icon: LocationIcon,
    href: URLS.profile.addresses,
  },
  {
    label: "profile.wishlist",
    icon: WishlistIcon,
    href: URLS.profile.wishlist,
  },
];

export const genderOptions = [
  { label: "male", value: "male" },
  { label: "female", value: "female" },
];
